import { useEffect, useState } from "react";
import { AvatarContainer, AvatarStyled, BrawlerName, BrawlersContainer, MainContainer, MainTitle } from "./brawlers.styles";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Footer } from "../../components/footer/footer";
import { screenBreackpoints } from "../../theme";
import { useTranslation } from "react-i18next";
import { Brawlers } from "../../api/brawlers/brawlers.types";
import { getBrawlers } from "../../api/brawlers/brawlers";
import { APP_ROUTES } from "../../routes/routes.constants";
import { useLanguage } from "../../hooks/language/language";
import { getUrlWithLang, nameToUrlFormatted } from "../../routes/routes.functions";
import { CardBtn, LinkStyled, PageContainer } from "../../components/base-components/base-componets";
import { SeoHelmet } from "../../components/seo-helmet/seo-helmet";
import { formatNameToTitleCase, getBrawlerImgSrc, ImageType } from "../../shared/functions";

export const BrawlersPage: React.FC = () => {
  const [brawlers, setBrawlers] = useState<Brawlers>();
  const isMobile = useMediaQuery(`(max-width:${screenBreackpoints.mobile})`);
  const { t } = useTranslation();
  const { getLanguage } = useLanguage();
  const language = getLanguage()

  useEffect(() => {
    const loadStats = async () => {
      try {
        const brawlers = await getBrawlers();
        const formattedBrawlers = brawlers.brawlers.map(b => ({
          ...b,
          name: formatNameToTitleCase(b.name)
        }));
        formattedBrawlers.sort((a, b) => a.name.localeCompare(b.name));
        //window.console.log(formattedBrawlers.map(it => it.name))
        setBrawlers({ ...brawlers, brawlers: formattedBrawlers });
      } catch (error) {
        window.console.log(error);
      }
    };
    loadStats();
  }, []);

  const title = t("PAGES.BRAWLERS.SEO.TITLE")
  const description = t("PAGES.BRAWLERS.SEO.DESCRIPTION")
  const keywords = t("PAGES.BRAWLERS.SEO.KEYWORDS")

  return (
    <>
      <SeoHelmet title={title} description={description} keywords={keywords} />
      <PageContainer isMobile={isMobile}>
        <Box>
          <MainTitle component="h1" isMobile={isMobile}>
            {title}
          </MainTitle>
          <Typography>
            {description}
          </Typography>
          <MainContainer>
            <BrawlersContainer>
              {brawlers && brawlers.brawlers.map(brawler => (
                <LinkStyled
                  key={brawler.name}
                  to={getUrlWithLang(language, `${APP_ROUTES.BRAWLER}/${nameToUrlFormatted(brawler.name)}`)}
                  aria-label={brawler.name}
                >
                  <CardBtn>
                    <AvatarContainer>
                      <AvatarStyled src={getBrawlerImgSrc(ImageType.AVATAR, brawler.name)}
                        alt={t("PAGES.RANKEDS.TABLE.AVATAR") + " " + brawler.name}>
                        <AvatarStyled src={getBrawlerImgSrc(ImageType.AVATAR)}
                          alt={t("PAGES.RANKEDS.TABLE.DEFAULT") + " " + t("PAGES.RANKEDS.TABLE.AVATAR")} />
                      </AvatarStyled>
                      <BrawlerName>
                        {brawler.name}
                      </BrawlerName>
                    </AvatarContainer>
                  </CardBtn>
                </LinkStyled>
              ))}
            </BrawlersContainer>
          </MainContainer>
        </Box>
        <Footer />
      </PageContainer>
    </>
  );
}
